$(function() {
    $('.categories-dropdown').change(function(){
        var selected = $(this).children("option:selected").val();
        storeHash(selected);
        $('.tab-pane').removeClass('active');
        $(selected).addClass('active');
    });

    $('#containsModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget)
        var contains = button.data('contains')
        var modal = $(this);
        modal.find('.modal-body span').html(contains)
    })

    if(window.location.hash != "") {
        $(".categories-dropdown").val(window.location.hash).trigger('change');
        $('a[href="' + window.location.hash + '"]').click()
    }

    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        storeHash(e.target.hash);
    })

    $('#menu-dishes').show();
});

function storeHash(hash) {
    if(history.pushState) {
        history.pushState(null, null, hash);
    } else {
        window.location.hash = hash; //Polyfill for old browsers
    }
}